import { Component, Input, Output, EventEmitter, OnInit, inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { WawiBelegArt } from "src/app/web-api/web-api";
import { UserService } from "src/app/services/user.service";
import { AnlageSearchComponent } from "src/app/anlage-api/components/search/anlage-search.component";
import { AnlageViewModel } from "src/app/planung-api/view-models";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";

@Component({
    selector: "app-wawi-beleg-create-form",
    templateUrl: "./form.component.html",
    styleUrls: ["./form.component.scss"],
    standalone: false
})
export class WawiApiBelegCreateFormComponent implements OnInit {
  private _fb = inject(FormBuilder);
  private _userService = inject(UserService);
  private _popupService = inject(CstResponsivePopupService);

  WawiBelegArt = WawiBelegArt;

  public form: FormGroup;
  @Input() loading = false;
  @Output() formCreated = new EventEmitter<FormGroup>();

  public get anlageNrInternCtrl() {
    return this.form.controls.anlageNrIntern;
  }
  public get anlageNrInternValue(): string[] {
    return this.anlageNrInternCtrl.value;
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      adressID: this._fb.control(
        null,
        Validators.compose([Validators.required, Validators.min(1)])
      ),
      info: this._fb.control(""),
      kennwort: this._fb.control(""),
      unserZeichen: this._fb.control(
        (this._userService.CurrentUser
          ? this._userService.CurrentUser.username
          : ""
        ).toUpperCase()
      ),
      belegart: this._fb.control(WawiBelegArt.Auftrag, Validators.required),
      belegdatum: this._fb.control(new Date(), Validators.required),
      gewLieferDatum: this._fb.control(null),
      bestTerminKunde: this._fb.control(null),
      produktlinie: this._fb.control("", Validators.required),
      ihreBestellung: this._fb.control(""),
      ihrZeichen: this._fb.control(""),
      anlageNrIntern: this._fb.control([]),
      taskID: this._fb.control(null),
    });
    this.formCreated.emit(this.form);
  }

  public OnSelectAnlage() {
    const popup = this._popupService.open(AnlageSearchComponent);
    popup.afterClosed().subscribe((result: AnlageViewModel) => {
      if (!result) {
        return;
      }
      const array = this.anlageNrInternValue;
      const idx = array.findIndex((x) => x === result.anlageNrIntern);
      if (idx >= 0) {
        return;
      }
      array.push(result.anlageNrIntern);
      this.anlageNrInternCtrl.setValue(array);
    })
  }

  public OnRemoveAnlage(anlageNr: string) {
    const array = this.anlageNrInternValue;
    const idx = array.findIndex((x) => x === anlageNr);
    if (idx < 0) {
      return;
    }
    array.splice(idx, 1);
    this.anlageNrInternCtrl.setValue(array);
  }
}
